import styled from 'styled-components';
import { StyledView } from 'components/common/CustomScrollbar/CustomScrollbar.styled';

export const AppointmentsPrintArea = styled.div`
  @media print {
    // Hide the whole page when printing appointments
    body:has(&) * {
      visibility: hidden;
    }

    // But show the print area and its children without shadows and with exact colors
    &,
    & * {
      visibility: visible !important;
      box-shadow: none !important;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    // Make everything what has scrollbar full height
    ${StyledView},
    *:has(> ${StyledView}) {
      overflow: visible !important;
      max-height: none !important;
      height: auto !important;
    }

    // Drop the positioning context from every ancestor
    // so absolute position is relative to the page
    *:has(&) {
      position: static !important;
    }

    // Make the print area full page width and height
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: auto;
    margin: 0;
    padding: 0;
  }
`;
